import {validateNoMarkdown} from '@github-ui/entity-validators'
import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {updateIssueBodyMutation, UpdateIssueInput} from './__generated__/updateIssueBodyMutation.graphql'

export function commitUpdateIssueBodyMutation({
  environment,
  input: {issueId, body, tasklistBlocksOperation},
  onCompleted,
  onError,
}: {
  environment: Environment
  input: {
    issueId: string
    body: string
    tasklistBlocksOperation?: string | null
  }
  onCompleted?: () => void
  onError?: (error: Error) => void
}) {
  const inputHash: UpdateIssueInput = {
    id: issueId,
    body,
    tasklistBlocksOperation,
  }

  return commitMutation<updateIssueBodyMutation>(environment, {
    mutation: graphql`
      mutation updateIssueBodyMutation($input: UpdateIssueInput!) @raw_response_type {
        updateIssue(input: $input) {
          issue {
            id
            ...IssueBodyContent
            ...MarkdownEditHistoryViewer_comment
          }
        }
      }
    `,
    optimisticResponse: validateNoMarkdown(body)
      ? {
          updateIssue: {
            issue: {
              id: issueId,
              body,
              bodyHTML: body,
              lastEditedAt: new Date().toISOString(),
              viewerCanReadUserContentEdits: true,
              __isComment: 'Issue',
            },
          },
        }
      : undefined,
    variables: {
      input: inputHash,
    },
    onCompleted: () => onCompleted && onCompleted(),
    onError: error => onError && onError(error),
  })
}
